import React, { useState } from "react";
import { useGetGiftcardCountriesQuery } from "../../../features/giftcards/giftcardsSlice";

interface CountryListProps {
  onSelect: (countryCode: string, countryName: string) => void;
}

export const CountryList: React.FC<CountryListProps> = ({ onSelect }) => {
  const { data: countries, isLoading, error } = useGetGiftcardCountriesQuery();
  const [search, setSearch] = useState("");

  const filteredCountries = countries?.filter((country) =>
    country.name.toLowerCase().includes(search.toLowerCase())
  );

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="h-16 bg-gray-800 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-500 text-center py-4">
        Failed to load countries. Please try again.
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search countries..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-white focus:outline-none focus:border-primary"
        />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {filteredCountries?.map((country) => (
          <button
            key={country.isoName}
            onClick={() => onSelect(country.isoName, country.name)}
            className="flex items-center gap-3 p-3 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors text-left"
          >
            <img
              src={country.flagUrl}
              alt={country.name}
              className="w-8 h-6 object-cover rounded"
              onError={(e) => {
                (e.target as HTMLImageElement).src = "https://via.placeholder.com/32x24";
              }}
            />
            <span className="text-white text-sm truncate">{country.name}</span>
          </button>
        ))}
      </div>

      {filteredCountries?.length === 0 && (
        <div className="text-gray-400 text-center py-8">
          No countries found matching "{search}"
        </div>
      )}
    </div>
  );
};
